const checkImageLoaded = () => {
  $(".job-employer-logo img").on('error', function () {
    $(this).unbind("error");
    $(this).hide();

    let defaultLogo = window.employerDefaultLogo;
    if (typeof defaultLogo !== 'undefined') {
      $(this).attr('src', defaultLogo);
      $(this).show();
    }
  });
};

$(checkImageLoaded);
